// extracted by mini-css-extract-plugin
export default {"icon":"_9Hd8oz1W0KyxA2g9-YqN7Q==","subtitle":"nmLxOvCjAashUYchaULN2A=="};